import type { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { ReconnectBanner } from '@/components/app/reconnect-banner';
import { AppErrorBoundary } from '@/components/app/error-boundary';
import { useThemeSync } from '@/stores/theme';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  useThemeSync();
  return (
    <AppErrorBoundary>
      <Outlet />
      <ReconnectBanner />
    </AppErrorBoundary>
  );
}
